<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ this.pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">Settings</li>
                            <li class="breadcrumb-item active">{{ this.pageName }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.pageName }}</h4>
                </div>
                <div class="card-body">
                    <section class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Price Slash Minimum Order Amount</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.price_slash_minimum_order_amount">
                                        <span v-if="configuration.errors.price_slash_minimum_order_amount"
                                              class="text-danger text-small">{{
                                                configuration.errors.price_slash_minimum_order_amount
                                            }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Price Slash Value</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.price_slash_value">
                                        <span v-if="configuration.errors.price_slash_value"
                                              class="text-danger text-small">{{
                                                configuration.errors.price_slash_value
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Price Slash Type</label>
                                        <select required class="form-control" v-model="configuration.price_slash_type">
                                            <option disabled value="">Select Price Slash Type</option>
                                            <option value="percentage">Percentage</option>
                                            <option value="amount">Amount</option>
                                        </select>
                                        <span v-if="configuration.errors.price_slash_type"
                                              class="text-danger text-small">
                                            {{ configuration.errors.price_slash_type }}
                                        </span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Price Slash Status</label>
                                        <select required class="form-control"
                                                v-model="configuration.price_slash_status">
                                            <option :value="true">Active</option>
                                            <option :value="false">Inactive</option>
                                        </select>
                                        <span v-if="configuration.errors.price_slash_status"
                                              class="text-danger text-small">
                                            {{ configuration.errors.price_slash_status }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary" @click="updatePriceSlashSettings">
                                    Update
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import QuillEditor from '../../Shared/QuillEditor';
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Configurations'},
    props: [
        'configurations',
        'configurationEnums',
        'pageName',
        'routeName',
    ],
    layout: Layout,
    name: 'ConfigurationIndex',
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            saving: false,
            configuration: this.$inertia.form({
                price_slash_minimum_order_amount: null,
                price_slash_value: null,
                price_slash_type: null,
                price_slash_status: null,
            }),
        };
    },
    mounted() {
        this.configuration.price_slash_minimum_order_amount = this.configurations.price_slash_minimum_order_amount;
        this.configuration.price_slash_value = this.configurations.price_slash_value;
        this.configuration.price_slash_type = this.configurations.price_slash_type;
        this.configuration.price_slash_status = this.configurations.price_slash_status;
    },

    methods: {
        async updatePriceSlashSettings() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.configuration.post(route(this.routeName), options);
            this.saving = false;
        },
    }
}
</script>
